import { render } from "./ProjectFilesSection.vue?vue&type=template&id=6e036b2c&scoped=true&ts=true"
import script from "./ProjectFilesSection.vue?vue&type=script&lang=ts"
export * from "./ProjectFilesSection.vue?vue&type=script&lang=ts"

import "./ProjectFilesSection.vue?vue&type=style&index=0&id=6e036b2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e036b2c"]])

export default __exports__